import { useNavigate } from "react-router-dom";
import { Users, UtensilsCrossed } from "lucide-react";
import { AdminShell } from "../components/AdminShell";
import { PaymentsTab } from "./AdminExtras";
import { Button } from "../components/ui/button";

const PagosPage = () => {
  const navigate = useNavigate();
  return (
    <AdminShell roles={["admin", "payment_reviewer"]} title="Revisión de pagos" testId="pagos-page"
      subtitle="Cola de comprobantes individuales y de grupo. Aprueba, rechaza o solicita correcciones; cada decisión queda auditada.">
      {(user) => (
        <>
          {user.role === "payment_reviewer" && (
            <div className="mb-4 flex flex-wrap gap-2" data-testid="reviewer-modules-nav">
              <Button variant="outline" size="sm" onClick={() => navigate("/admin?tab=asistentes")} data-testid="reviewer-goto-asistentes" className="font-semibold">
                <Users className="mr-1 h-4 w-4" /> Asistentes
              </Button>
              <Button variant="outline" size="sm" onClick={() => navigate("/admin?tab=cena")} data-testid="reviewer-goto-cena" className="font-semibold">
                <UtensilsCrossed className="mr-1 h-4 w-4" /> Cena
              </Button>
            </div>
          )}
          <PaymentsTab readOnly={false} role={user.role} />
        </>
      )}
    </AdminShell>
  );
};

export default PagosPage;
